jQuery(document).ready(function() {

    const contactForm = document.getElementById("kontaktaoss");
    const eventsForm  = document.getElementById("form_event");

    // * getElementById => return null if no matching element was found in the document.

    if ( contactForm !== null ) {

        grecaptcha.ready(function() {
            
            const rcBadge = document.querySelector(".grecaptcha-badge");
            const rcBadgeTarget = document.getElementById('kontaktaoss');

            rcBadgeTarget.appendChild(rcBadge);
            rcBadge.style.opacity = 1;     
            
            console.log("Google reCaptcha => Loaded OK!");
            console.log("Google reCaptcha => Badge has moved!");
            console.log('Google reCaptcha => Badge shows in contact section now!');

        });

    }

    if ( eventsForm !== null ) {

        grecaptcha.ready(function() {

            const rcBadge = document.querySelector(".grecaptcha-badge");
            const rcBadgeTarget = document.getElementById('main');    

            rcBadgeTarget.appendChild(rcBadge);
            rcBadge.style.opacity = 1;  
            
            console.log("Google reCaptcha => Loaded OK!");
            console.log("Google reCaptcha => Badge has moved!");
            console.log('Google reCaptcha => Badge shows in main section now!');
            
               
            
        });

    }
    
}); // DOM Ready?
